const normalizeCountriesAvailable = countriesAvailable => {
  if (countriesAvailable == null) {
    return [];
  }
  if (Array.isArray(countriesAvailable)) {
    return countriesAvailable;
  }
  if (typeof countriesAvailable === 'string') {
    try {
      const parsed = JSON.parse(countriesAvailable);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

export const checksIncludeUsMarketWithFcra = (checks, checkTypes) => {
  const list = checks || [];
  const types = checkTypes || [];
  if (!list.length || !types.length) {
    return false;
  }
  return list.some(check => {
    const ct = types.find(t => t.slug === check.type);
    if (!ct || !ct.has_fcra) {
      return false;
    }
    return normalizeCountriesAvailable(ct.countries_available).includes('US');
  });
};

export const hasFCRAChecks = (checks, companyChecks) => {
  return (checks || []).some(check => {
    const selectedCheck = companyChecks?.find(cc => cc.type === check.type);
    return selectedCheck?.check_type?.has_fcra;
  });
};

export const shouldPromptFcraConsent = (checks, companyChecks, checkTypes, companyCountry) => {
  const list = checks || [];
  if (!list.length) {
    return false;
  }

  if (companyCountry === 'US' && hasFCRAChecks(list, companyChecks)) {
    return true;
  }

  if (Array.isArray(checkTypes) && checkTypes.length > 0) {
    return checksIncludeUsMarketWithFcra(list, checkTypes);
  }

  return false;
};
